// localization
import i18next from 'i18next'
import * as types from '../mutationTypes'

const state = {
  locale: 'en'
}

const getters = {
  locale: state => state.locale
}
const mutations = {
  [types.SET_LOCALE] (state, locale) {
    state.locale = locale
  }
}

const actions = {
  setLocale ({ commit }, locale) {
    i18next.init({
      interpolation: {
        format: function (value, format, lng) {
          if (format === 'uppercase') return value.toUpperCase()
          if (format === 'capitalize') return value.charAt(0).toUpperCase() + value.slice(1)
          return value
        }
      },
      lng: locale,
      resources: {
        en: require('../../../locales/en/main.json')
      }
    }, (err, t) => {
      if (err) {
        throw err
      }
      commit(types.SET_LOCALE, locale)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
